import React from 'react'
import { Link } from 'react-router-dom';

const AbtCompany = () => {
  return (
    <>
    <section class="mosh-aboutUs-area section_padding_100_0">
        <div class="container">
            <div class="row align-items-center mt-5 mb-5">
                <div class="col-12 col-md-6">
                    <div class="mosh-about-us-content">
                        <div class="section-heading">
                            <h2><span className="green-span">Welcome to MIPAT</span>
                            <br />Modern Integrated Farms and Food Processing Ltd</h2>
                        </div>
                        
                        <p>MIPAT Modern Integrated Farms and Food Processing Ltd is an indigenous Nigerian registered company 
                        specialized in the processing of natural and organic resources. We introduce three (3) unique 
                        products to you &mdash; </p>
                        <p>1. <b>SpillClean Powder</b>: Spillage cleaning solution for hydrocarbons, 
                        automotive fluids, grease, industrial cleansers, chemicals, paints.</p>

                        <p>2. <b>Fertilizer and Water Mixing Machine</b>: <i>Brief info about product</i></p>
                        <p>3. <b>Cocopeat &amp; Coconut Husk Chips</b>: <i>Brief info about product</i></p>

                        <Link to="/about" class="btn mosh-btn mt-4">about company</Link>
                        <Link to="/products" class="btn ml-2 mt-4 text-danger" 
                            style={{ border: '1px solid #E4353A', borderRadius: '5rem', 
                                padding: '.55rem 1.2rem'}}>Shop Products</Link>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="mosh-about-us-thumb wow fadeInUp" data-wow-delay="0.5s">
                        <img src="img/bg-img/headpiece.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section class="mosh-about-features-area section_padding_50 bg-grey">
        <div class="container">
            <div class="row align-items-center my-4">

                <div class="col-12 col-md-4">
                    <div class="mosh-features-thumb wow fadeIn" data-wow-delay="0.5s">
                        <img src="img/bg-img/features-2.png" alt="" />
                    </div>
                </div>

                <div class="col-12 col-md-8">
                    <div class="mosh-about-us-content">
                        <div class="section-heading">
                            {/* <p>Features</p> */}
                            <h2><span className="green-span">Why choose MIPAT?</span><br /> 
                                Qualities that make us unique</h2>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="single-feature-area d-flex">
                                    <div class="feature-icon mr-30">
                                        <img src="img/core-img/settings-2.png" alt="" />
                                    </div>
                                    <div class="feature-content">
                                        <h5>A big team</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div> 

                            <div class="col-12 col-sm-6">
                                <div class="single-feature-area d-flex">
                                    <div class="feature-icon mr-30">
                                        <img src="img/core-img/photo-camera.png" alt="" />
                                    </div>
                                    <div class="feature-content">
                                        <h5>Photo enthuziast</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div> 

                            <div class="col-12 col-sm-6">
                                <div class="single-feature-area d-flex">
                                    <div class="feature-icon mr-30">
                                        <img src="img/core-img/like.png" alt="" />
                                    </div>
                                    <div class="feature-content">
                                        <h5>30k Followers</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-12 col-sm-6">
                                <div class="single-feature-area d-flex">
                                    <div class="feature-icon mr-30">
                                        <img src="img/core-img/gamepad.png" alt="" />
                                    </div>
                                    <div class="feature-content">
                                        <h5>We love gaming</h5>
                                        <p>Etiam nec odio vestibulum est mat tis effic iturut magna.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="#" class="btn mosh-btn mt-50">Read More</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
export default AbtCompany; 